import { axiosInstance } from '../../api';
const BASE_PATH = '/approvals';

//Get Assigned Offer Approvals
export let getAssignedOfferApprovals = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_assigned_offer_approvals')
        return value;
    } catch (error) {
        return error
    }
}

export let approveOffer = async (offer_session) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/approve_offer',{
            offer_session_id: offer_session
        });
        return value;
    } catch (error) {
        return error
    }
}

export let rejectOffer = async (offer_session,reason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/reject_offer',{
            offer_session_id: offer_session,
            rejected_reason: reason
        });
        return value;
    } catch (error) {
        return error
    }
}